import { render, staticRenderFns } from "./OwnerRawDialog.vue?vue&type=template&id=a84e5cce&scoped=true&"
import script from "./OwnerRawDialog.vue?vue&type=script&lang=js&"
export * from "./OwnerRawDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84e5cce",
  null
  
)

export default component.exports